import { PageConfig } from "../../../components/content-blocks/forms/customer-form-types";
import { aeChoices } from "../config-generics/aeKao";

export const budgetConfig: PageConfig[] = [
  {
    name: "budgetIncome",
    title: "Other Sources of Funding",
    description: `
      Please provide details of any other sources of funding or income you have
      confirmed or pending for this initiative.
    `,
    questions: [
      {
        type: "matrixdynamic",
        name: "income",
        title: "Income / Funds",
        description: "All $ Ex GST",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        columns: [
          {
            name: "incomeFunder",
            title: "Funding Source",
            cellType: "text",
          },
          {
            name: "incomeConfirmed",
            title: "Confirmed",
            cellType: "checkbox",
            choices: aeChoices,
          },
          {
            name: "incomeAmount",
            title: "Amount",
            cellType: "text",
            totalType: "sum",
            // eslint-disable-next-line no-template-curly-in-string
            totalFormat: "Total: ${0}",
            inputType: "number",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
      {
        type: "comment",
        name: "fundingDetails",
        title:
          "Please provide details of any other sources of funding or income you have confirmed or pending for this initiative.",
        placeHolder: "Ētahi atu pūtea",
      },
    ],
  },
  {
    name: "budgetExpenditure",
    title: "Budget Expenditure",
    description: "Please provide details of your planned expenses below.",
    questions: [
      {
        type: "matrixdynamic",
        name: "expenditure",
        title: "Expenditure",
        description: "All $ Ex GST",
        addRowText: "Add Row",
        columnMinWidth: "130px",
        columns: [
          {
            name: "expenditureType",
            title: "Expenditure Type",
            isRequired: true,
            choices: [
              "Communications",
              "Catering",
              "Transport",
              "Venue Hire",
              "Equipment Hire / Purchase",
              "Other",
            ],
          },
          {
            name: "expenditureDetails",
            title: "Description or Provider Name",
            cellType: "text",
            isRequired: true,
          },
          {
            name: "expenditureBudget",
            title: "Budget",
            cellType: "text",
            isRequired: true,
            totalType: "sum",
            // eslint-disable-next-line no-template-curly-in-string
            totalFormat: "Total: ${0}",
            inputType: "number",
            totalAlignment: "right",
          },
        ],
        rowCount: 1,
        minRowCount: 1,
        maxRowCount: 100,
      },
    ],
  },
  {
    name: "budgetSummary",
    title: "Budget Summary",
    questions: [
      {
        type: "expression",
        name: "budgetSummaryExpenditure",
        title: "Total Event Cost",
        expression: "{expenditure-total.expenditureBudget}",
        displayStyle: "currency",
        currency: "NZD",
      },
      {
        type: "expression",
        name: "budgetSummaryIncome",
        title: "Total Event Income (including requested funding)",
        expression: "{income-total.incomeAmount} + {requestedAmount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
      {
        type: "expression",
        name: "budgetSummaryShortfall",
        title: "Current Budget Shortfall",
        expression:
          "{expenditure-total.expenditureBudget} - {income-total.incomeAmount} - {requestedAmount}",
        displayStyle: "currency",
        startWithNewLine: false,
        currency: "NZD",
      },
    ],
  },
];
